import { useQuery } from '@tanstack/react-query';

import { getSlidesDataForArtifactsResults } from 'api/study';
import { CasesParams } from 'utils/useCasesParams/types';

export const useSlidesDataForArtifactsResultsQuery = (casesParams: CasesParams) =>
  useQuery({
    queryKey: ['slidesDataForArtifactsResults', casesParams],
    queryFn: ({ signal }) => getSlidesDataForArtifactsResults(casesParams, signal),
    retry: false,
    enabled: Boolean(casesParams?.studyId),
  });
